import { render, staticRenderFns } from "./template3.vue?vue&type=template&id=d43c86ec&scoped=true"
import script from "./template3.vue?vue&type=script&lang=js"
export * from "./template3.vue?vue&type=script&lang=js"
import style0 from "./template3.vue?vue&type=style&index=0&id=d43c86ec&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d43c86ec",
  null
  
)

export default component.exports